import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import Chart from "Components/Common/Chart";
import { complianceLevelBarChartColors } from "common/constant";

const ComplianceLevelsByBuildingBarChart = ({ chartData, t }) => {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const initialOptions = {
    chart: {
      type: "bar",
      stacked: true,
      events: {
        legendClick: (chart, event) => {
          setSelectedIndex((prevIndex) => (prevIndex === event ? null : event));
        },
      },
    },
    colors: complianceLevelBarChartColors,
    plotOptions: {
      bar: {
        distributed: true,
        horizontal: false,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontWeight: 700,
          fontSize: "14px",
          colors: "#000",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "left",
      offsetX: 40,
    },
  };

  const filteredData = useMemo(() => {
    if (selectedIndex === null) return data;
    return data.map((value, index) => (index !== selectedIndex ? value : 0));
  }, [data, selectedIndex]);

  const series = [
    {
      name: "Compliance Levels By Building",
      data: filteredData,
    },
  ];

  useEffect(() => {
    if (chartData.length) {
      const barChartLabels = chartData.map((item) => item.category);
      const barChartData = chartData.map((item) => item.count);

      setCategories(barChartLabels);
      setData(barChartData);
    }
  }, [chartData]);

  return (
    <Chart
      title={t("Compliance Levels By Building")}
      options={initialOptions}
      series={series}
      height={350}
      type="bar"
    />
  );
};

ComplianceLevelsByBuildingBarChart.propTypes = {
  chartData: PropTypes.array.isRequired,
  t: PropTypes.func,
};

export default withTranslation()(ComplianceLevelsByBuildingBarChart);
